<template>
  <button class="button-wrapper" @click.stop="$emit('click')">
    <svg :class="['icon', { spinning: spinWhile }]" width="14" height="14" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g v-html="getIconPath('refresh')"></g>
    </svg>
    {{ title }}
  </button>
</template>

<script setup>
import { getIconPath } from '@/Modules/utils/icons';

const props = defineProps({
  title: {
    type: String,
    required: true
  },
  spinWhile: {
    type: Boolean,
    default: false
  }
})
</script>

<style scoped>
.button-wrapper {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 10px 16px;
  border-radius: 12px;
  cursor: pointer;
  user-select: none;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
  border: 1px solid rgba(0, 0, 0, 0.08);
  position: relative;
  overflow: hidden;
  background: rgba(255, 255, 255, 0.95);
  backdrop-filter: blur(10px);
  color: #6b7280;
  font-size: 14px;
  font-weight: 500;
  height: 100%;
}

.button-wrapper::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: linear-gradient(90deg, rgba(123, 24, 28, 0.05) 0%, rgba(123, 24, 28, 0.02) 100%);
  opacity: 0;
  transition: opacity 0.3s ease;
}

.button-wrapper:hover::before {
  opacity: 1;
}

.button-wrapper:hover {
  color: var(--highlights);
  border-color: rgba(123, 24, 28, 0.2);
  box-shadow: 0 4px 12px rgba(123, 24, 28, 0.15);
}

.button-wrapper:active {
  transform: scale(0.98);
}

.icon {
  transition: transform 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}

.button-wrapper:hover .icon {
  transform: rotate(-180deg);
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

.spinning {
  animation: spin 1s linear infinite;
}
</style>